import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import '../../../../App.css'
import {SENDOTP_MUTATION, VERIFY_OTP_FORGOT_PASSWORD_MUTATION} from '../../../GraphQLQueries/Auth'
import useMutationApi from '../../../../hooks/useMutation'
import {ToastMessageContainer} from '../../../../_ePulse/layout/components/ToastMessageContainer'
import {toast} from 'react-toastify'
import {LoadingSpinner} from '../../../../_ePulse/layout/components/LoadingSpinner'
const initialValues = {
  otp: '',
  password: '',
  confirmPassword: '',
}

const forgotPasswordSchema = Yup.object().shape({
  otp: Yup.string().required('OTP is required'),
  password: Yup.string().required('Password is required'),
  confirmPassword: Yup.string().required('Confirm Password is required'),
})

export function NewPassword() {
  const location = useLocation()
  const navigate = useNavigate()
  const {email, resendOtpTime}: any = location.state

  const [isloading, setLoading] = useState(false)
  const [minutes, setMinutes] = useState(resendOtpTime ? resendOtpTime.replace('m', '') : 2)
  const [seconds, setSeconds] = useState(0)
  const [hasErrorsmsg, setHasErrorsmsg] = useState<any>('')

  const {createData, loading, error, data} = useMutationApi(VERIFY_OTP_FORGOT_PASSWORD_MUTATION)

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)

      if (values.password !== values.confirmPassword) {
        // setHasErrors(true)
        toast.error('Password and Confirm Password are not same.')
        setHasErrorsmsg('Password & Confirm Password are not same')
        setLoading(false)
      } else {
        try {
          await createData({
            email: email,
            otp: parseInt(values.otp),
            newPassword: values.password,
          })

          toast.success('Password updated successfully. Please login again.')
          setTimeout(() => {
            setLoading(false)
            navigate(`/auth`)
          }, 2000)
        } catch (error: any) {
          setHasErrorsmsg(error?.message)
          // setHasErrors(true)
          setLoading(false)
        }
      }
    },
  })

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval)
        } else {
          setSeconds(59)
          setMinutes(minutes - 1)
        }
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [seconds, minutes])

  const {
    createData: resendOtp,
    data: resendotpData,
    loading: resendotpLodaing,
    error: resendotpError,
  } = useMutationApi(SENDOTP_MUTATION)

  const resend = async () => {
    const res = await resendOtp({
      email: email.toLowerCase(),
    })
    console.log('Resend OTP Response', res)
    if (process.env.REACT_APP_ENV === 'PROD') {
      toast.success('OTP sent successfully on registered email Id.')
    } else {
      alert(res.data.getAdminResetPasswordOtp.otp)
    }
    setMinutes(
      res.data.getAdminResetPasswordOtp.resendOtpTime
        ? res.data.getAdminResetPasswordOtp.resendOtpTime.replace('m', '')
        : 2
    )

    setSeconds(0)
  }

  return (
    <>
      <ToastMessageContainer />
      <LoadingSpinner isLoading={loading || isloading} />
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>Enter OTP & New Password</h1>
          {/* end::Title */}

          {/* begin::Link */}
          {/* <div className='text-gray-400 fw-bold fs-4'>No worries, we’ll send you reset instructions</div> */}
          {/* end::Link */}
        </div>

        {/* begin::Title */}
        {/* {hasErrors === true && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>{hasErrorsmsg}</div>
          </div>
        )} */}

        {/* {hasErrors === false && (
          <div className='mb-10 bg-light-info p-8 rounded'>
            <div className='text-info'>{hasErrorsmsg}</div>
          </div>
        )} */}
        {/* end::Title */}

        {/* begin::Form group */}
        <div className='fv-row mb-10'>
          <label className='form-label fw-bolder text-gray-900 fs-6'>OTP</label>
          <input
            placeholder=''
            maxLength={6}
            {...formik.getFieldProps('otp')}
            className={clsx('form-control form-control-lg form-control-solid')}
          />
          {formik.touched.otp && formik.errors.otp && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.otp}</span>
              </div>
            </div>
          )}
          <label className='form-label fw-bolder text-gray-900 fs-6'>Password</label>
          <input
            type='password'
            placeholder=''
            {...formik.getFieldProps('password')}
            className={clsx('form-control form-control-lg form-control-solid')}
          />
          {formik.touched.password && formik.errors.password && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.password}</span>
              </div>
            </div>
          )}
          <label className='form-label fw-bolder text-gray-900 fs-6'>Confirm Password</label>
          <input
            type='password'
            placeholder=''
            {...formik.getFieldProps('confirmPassword')}
            className={clsx('form-control form-control-lg form-control-solid')}
          />
          {formik.touched.confirmPassword && formik.errors.confirmPassword && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.confirmPassword}</span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}

        <div className='d-flex flex-column justify-content-center align-items-center '>
          <div className='d-flex flex-row justify-content-between mb-3 align-items-center'>
            {seconds > 0 || minutes > 0 ? (
              <p className='m-0'>
                Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                {seconds < 10 ? `0${seconds}` : seconds}
              </p>
            ) : (
              <p className='m-0'>Didn't recieve code?</p>
            )}

            <button
              type='button'
              disabled={seconds > 0 || minutes > 0}
              // style={
              //   {
              //     // color: seconds > 0 || minutes > 0 ? '#DFE3E8' : '#FF5630',
              //   }
              // }
              className={
                seconds > 0 || minutes > 0
                  ? 'ms-3 text-dark ePulse-button-disabled'
                  : 'ms-3 text-dark ePulse-button-secondory'
              }
              onClick={() => resend()}
            >
              Resend OTP
            </button>
          </div>
          <button type='submit' id='kt_password_reset_submit' className='ePulse-btn-primary'>
            <span className='indicator-label text-white'>Update Password</span>
            {isloading && (
              <span className='indicator-progress'>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>

          <button
            type='button'
            id='kt_login_password_reset_form_cancel_button'
            className='mt-3 ePulse-btn-secondory'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            <Link to='/auth' className='indicator-label text-dark'>
              Go back to login
            </Link>
          </button>
        </div>

        {/* end::Form group */}
      </form>
    </>
  )
}
